import ReminderTabContent from "../../../reminders/external-components/ReminderTabContent/ReminderTabContent";
import useGetProviderReminders from "../../api/useGetProviderReminders";

type Props = {
  providerId: string;
}

export default function ReminderTabContentWrapper(props: Props) {
  const { data: currentReminders, isLoading: currentLoading } = useGetProviderReminders(props.providerId, false);
  const { data: pastReminders, isLoading: pastLoading } = useGetProviderReminders(props.providerId, true);

  return (
    <ReminderTabContent
      currentReminders={currentReminders ?? []}
      currentLoading={currentLoading}
      pastReminders={pastReminders ?? []}
      pastLoading={pastLoading}
      displayProvider={false}
      displaySubject
    />
  )
}
